import React, {memo} from 'react';
import {AdminForm} from '../../Component/Form/AdminForm';
import {AdminCrudPage} from '../../Component/Page/AdminCrudPage';

export const OrganisationAdminAddScreen: React.FC = memo(() => (
  <AdminCrudPage entityType="organisation" action="Add">
    <AdminForm redirectUrl="/admin/organisation" mutationName="addOrganisation"/>
  </AdminCrudPage>
));
